import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Slider } from '@osmosis/tailwind-ui/components/Slider';
import { useVideoPlayer } from '../../context/VideoPlayerProvider';
import { useIntl } from 'react-intl';

/**
 * Slider to control video volume.
 */
export default function VolumeSlider(): JSX.Element {
  const videoPlayer = useVideoPlayer();
  const { volume = 0, setVolume } = videoPlayer;
  const intl = useIntl();

  return (
    <Box cn="p-2">
      <Flex cn="justify-center items-end relative">
        <Box cn="w-[60px]">
          <Slider
            onKeyDown={(e) => e.stopPropagation()}
            min={0}
            max={100}
            step={1}
            value={[volume * 100]}
            onValueChange={(value) => setVolume(Number(value) / 100)}
            orientation="horizontal"
            ariaValueText={`${Math.floor(volume * 100)}% audio volume`}
            ariaLabelThumb={intl.formatMessage({
              id: 'video_control_bar.volume_slider',
              defaultMessage: 'Audio volume',
            })}
          />
        </Box>
      </Flex>
    </Box>
  );
}
